import { filter, get, head } from 'lodash'

export default {
    getDspParentName: (parentJsonKeyName, dsps) => {
        const parent = head(filter(dsps, dsp => dsp.jsonKey.name === parentJsonKeyName))
        return get(parent, 'label', null)
    },
    getDspParentKey: (parentJsonKeyName, dsps) => {
        const parent = head(filter(dsps, dsp => dsp.jsonKey.name === parentJsonKeyName))
        return get(parent, 'keyLabel', null)
    }
}
